// Reference: https://jasonwatmore.com/post/2019/06/10/angular-8-user-registration-and-login-example-tutorial#login-component-html

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthService } from '../_services';
import { ToastrService } from 'ngx-toastr';
import { ErrorMessageService } from '../_services/errormessage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService, private toastrs: ToastrService, private errorMessage: ErrorMessageService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            /*catchError((error: HttpErrorResponse) => {
                if (err.status === 401) {
                    // auto logout if 401 response returned from api
                    this.authenticationService.SignOut();
                    location.reload();
                }
            const error = err.error.message || err.statusText;
            return throwError(error);
        }),*/
        tap(
        () => {},
        error => {
            let errorMsg = '';
            if (error.error instanceof ErrorEvent) {
                console.log('This is client side error');
                errorMsg = `Error: ${error.error.message}`;
            } else {
                console.log('This is server side error');
                errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
                if (error.error && error.error.commandMessages) {
                    const messages = error.error.commandMessages.map((c: any) => this.errorMessage.get(c.key)).join("<br />")
                    this.toastrs.error(messages);
                }
                else {
                    this.toastrs.error(`Une erreur innattendue est survenue: ${error.message}`);
                }
            }
            console.log(errorMsg);
            return throwError(() => new Error(errorMsg));
        }))
    }
}